import { render, staticRenderFns } from "./NeoDrawerLayout.vue?vue&type=template&id=2f88009a&scoped=true&"
import script from "./NeoDrawerLayout.vue?vue&type=script&lang=js&"
export * from "./NeoDrawerLayout.vue?vue&type=script&lang=js&"
import style0 from "./NeoDrawerLayout.vue?vue&type=style&index=0&id=2f88009a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88009a",
  null
  
)

export default component.exports